import ContentLoader from 'react-content-loader'
import {FC, ReactElement} from 'react'

type Props = {
  width?: number
  classes?: string
  height?: number
}

export const ColumnSkeleton: FC<Props> = ({
  width = 50,
  height = 10,
  classes,
}) => {
  return (
    <ContentLoader
      speed={2}
      width={width - 30}
      height={height}
      viewBox={`0 0 ${width + 10} ${height}`}
      backgroundColor="#333"
      foregroundColor="#222"
      className={classes}
      data-cy="column-skeleton"
    >
      <rect rx="5" ry="5" width={width} height={height} />
    </ContentLoader>
  )
}

export const EmptyTdElement: FC<Props> = () => {
  return <td className="tableTdThWidth"></td>
}

export const CommonTdForBypass: FC<{children?: ReactElement}> = ({
  children,
}) => {
  return <td className="border-b-0.5 border-gray-600">{children}</td>
}
